import { render, staticRenderFns } from "./viewImage.vue?vue&type=template&id=71e935fc&scoped=true"
import script from "./viewImage.vue?vue&type=script&lang=js"
export * from "./viewImage.vue?vue&type=script&lang=js"
import style0 from "./viewImage.vue?vue&type=style&index=0&id=71e935fc&prod&lang=scss&scoped=true"
import style1 from "./viewImage.vue?vue&type=style&index=1&id=71e935fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e935fc",
  null
  
)

export default component.exports